import React from 'react'

export const GetOrasFracttalByPlanta = (empresa, annio, semana) => {
  return new Promise(async function(resolve, reject) {
      try {
        const query = await fetch(`https://ariztock.apidev.info/api/fracttal/getwohours?planta=${empresa}&annio=${annio}&semana=${semana}`)
        // const query = await fetch(`http://10.30.11.7:4082/api/fracttal/getwohours?planta=${empresa}&annio=${annio}&semana=${semana}`)
  
          const reqkkst = await query.json();
          // console.log('el rutttt=>>>>>>>',reqkkst)
          if(reqkkst.colaboradores.length > 0){
            resolve(reqkkst)
          }else{
            resolve([])
          }
        } catch (error) {  
          resolve([])
        }
    })
}
